// Extrait du proto Modules/12M Cash/treso_v9.jsx (lignes 217-247).
// VERBATIM — répartit le montant mensuel ou annuel sur les moisActifs.

export const computeMensuelValeurs = (charge) => {
  if (!charge) return Array(12).fill(0);
  const valeurs = Array(12).fill(0);
  // Migration : si pas de moisActifs, on suppose que toute l'année est active
  const moisActifs = Array.isArray(charge.moisActifs) ? charge.moisActifs : [0,1,2,3,4,5,6,7,8,9,10,11];
  if (moisActifs.length === 0) return valeurs;
  const montant = Number(charge.montant) || 0;
  if (charge.mode === 'annuel') {
    // Réparti sur les mois cochés
    const parMois = montant / moisActifs.length;
    moisActifs.forEach(m => { if (m >= 0 && m < 12) valeurs[m] = parMois; });
  } else {
    // mode 'mensuel' (par défaut) : montant identique chaque mois actif
    moisActifs.forEach(m => { if (m >= 0 && m < 12) valeurs[m] = montant; });
  }
  return valeurs;
};

export const computeSpecifiqueValeurs = (charge) => {
  const valeurs = Array(12).fill(0);
  const moisActifs = Array.isArray(charge?.moisActifs) ? charge.moisActifs : [];
  if (moisActifs.length === 0) return valeurs;
  const montant = Number(charge.montant) || 0;
  if (charge.mode === 'mensuel') {
    moisActifs.forEach(m => { valeurs[m] = montant; });
  } else {
    const parMois = montant / moisActifs.length;
    moisActifs.forEach(m => { valeurs[m] = parMois; });
  }
  return valeurs;
};
